import React from "react";

export const SupportReportIssueAddIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" fill="white" />
  </svg>
);

export const SupportTransactionCopyIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.66653 4.00065V2.00065C4.66653 1.63246 4.96501 1.33398 5.3332 1.33398H13.3332C13.7014 1.33398 13.9999 1.63246 13.9999 2.00065V11.334C13.9999 11.7022 13.7014 12.0006 13.3332 12.0006H11.3332V14C11.3332 14.3686 11.0333 14.6673 10.662 14.6673H2.67111C2.30039 14.6673 2 14.3709 2 14L2.00173 4.6679C2.0018 4.29939 2.30176 4.00065 2.67295 4.00065H4.66653ZM5.99987 4.00065H11.3332V10.6673H12.6665V2.66732H5.99987V4.00065Z"
      fill="#0033FF"
    />
  </svg>
);

export const SupportStatusResolvedIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.927 23.6999C6.97722 23.6999 2.1543 18.877 2.1543 12.9272C2.1543 6.97747 6.97722 2.15454 12.927 2.15454C18.8767 2.15454 23.6996 6.97747 23.6996 12.9272C23.6996 18.877 18.8767 23.6999 12.927 23.6999ZM11.8529 17.2363L19.4692 9.61892L17.946 8.09567L11.8529 14.1898L8.80534 11.1422L7.28209 12.6654L11.8529 17.2363Z"
      fill="white"
    />
  </svg>
);

export const SupportStatusInProgressIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.9272 23.6999C6.97747 23.6999 2.15454 18.877 2.15454 12.9272C2.15454 6.97747 6.97747 2.15454 12.9272 2.15454C18.877 2.15454 23.6999 6.97747 23.6999 12.9272C23.6999 18.877 18.877 23.6999 12.9272 23.6999ZM12.9272 21.5453C15.2129 21.5453 17.4049 20.6374 19.0212 19.0212C20.6374 17.4049 21.5453 15.2129 21.5453 12.9272C21.5453 10.6415 20.6374 8.44948 19.0212 6.83327C17.4049 5.21705 15.2129 4.30907 12.9272 4.30907C10.6415 4.30907 8.44948 5.21705 6.83327 6.83327C5.21705 8.44948 4.30907 10.6415 4.30907 12.9272C4.30907 15.2129 5.21705 17.4049 6.83327 19.0212C8.44948 20.6374 10.6415 21.5453 12.9272 21.5453ZM14.0045 12.9272H18.3135V15.0817H11.8499V7.54088H14.0045V12.9272Z"
      fill="white"
    />
  </svg>
);

export const SupportIssueDidNotReceiveIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.3288 25.5504C21.7425 25.5504 26.9418 20.3511 26.9418 13.9374C26.9418 7.52377 21.7425 2.32446 15.3288 2.32446C8.91513 2.32446 3.71582 7.52377 3.71582 13.9374C3.71582 20.3511 8.91513 25.5504 15.3288 25.5504Z" stroke="#0033FF" strokeWidth="2.3226" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.3296 9.29248V13.9377" stroke="#0033FF" strokeWidth="2.3226" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.3296 18.5793H15.3421" stroke="#0033FF" strokeWidth="2.3226" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SupportIssueWrongChargeIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M24.6202 5.80835H6.03939C4.75666 5.80835 3.7168 6.84821 3.7168 8.13095V19.7439C3.7168 21.0267 4.75666 22.0665 6.03939 22.0665H24.6202C25.9029 22.0665 26.9428 21.0267 26.9428 19.7439V8.13095C26.9428 6.84821 25.9029 5.80835 24.6202 5.80835Z" stroke="#0033FF" strokeWidth="2.3226" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.7168 11.6113H26.9428" stroke="#0033FF" strokeWidth="2.3226" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SupportIssueUnauthorizedIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.3288 25.5503C21.7425 25.5503 26.9418 20.351 26.9418 13.9373C26.9418 7.52365 21.7425 2.32434 15.3288 2.32434C8.91513 2.32434 3.71582 7.52365 3.71582 13.9373C3.71582 20.351 8.91513 25.5503 15.3288 25.5503Z" stroke="#0033FF" strokeWidth="2.3226" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.0835 5.6886L23.5739 22.179" stroke="#0033FF" strokeWidth="2.3226" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SupportIssueOtherIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15.3298 25.5503C21.7435 25.5503 26.9428 20.351 26.9428 13.9373C26.9428 7.52365 21.7435 2.32434 15.3298 2.32434C8.91611 2.32434 3.7168 7.52365 3.7168 13.9373C3.7168 20.351 8.91611 25.5503 15.3298 25.5503Z" stroke="#0033FF" strokeWidth="2.3226" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11.9502 10.4497C12.2232 9.67361 12.7621 9.01915 13.4714 8.60227C14.1808 8.1854 15.0147 8.03301 15.8257 8.1721C16.6366 8.3112 17.3721 8.73279 17.9019 9.36222C18.4318 9.99165 18.7218 10.7883 18.7206 11.611C18.7206 13.9336 15.2367 15.0949 15.2367 15.0949" stroke="#0033FF" strokeWidth="2.3226" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M15.3296 19.7443H15.3421" stroke="#0033FF" strokeWidth="2.3226" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const SupportIssueSendIcon = (
  props: React.SVGProps<SVGSVGElement>,
) => (
  <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M0 9.33336C0 4.17869 4.17869 0 9.33336 0H32.6659C37.8206 0 41.9993 4.17869 41.9993 9.33336V32.6659C41.9993 37.8206 37.8206 41.9993 32.6659 41.9993H9.33336C4.17869 41.9993 0 37.8206 0 32.6659V9.33336Z" fill="#0033FF" />
    <path d="M22.9726 28.5335C23.0021 28.6072 23.0535 28.67 23.1198 28.7136C23.1861 28.7572 23.2641 28.7795 23.3434 28.7775C23.4228 28.7754 23.4996 28.7492 23.5635 28.7023C23.6275 28.6553 23.6756 28.5899 23.7013 28.5149L28.7568 13.7373C28.7817 13.6684 28.7864 13.5938 28.7705 13.5223C28.7545 13.4508 28.7186 13.3853 28.6667 13.3335C28.6149 13.2817 28.5494 13.2457 28.4779 13.2298C28.4064 13.2138 28.3318 13.2186 28.2629 13.2435L13.4854 18.2989C13.4103 18.3247 13.3449 18.3728 13.298 18.4367C13.2511 18.5007 13.2248 18.5775 13.2228 18.6568C13.2208 18.7361 13.243 18.8142 13.2866 18.8805C13.3302 18.9468 13.3931 18.9981 13.4667 19.0277L19.6344 21.501C19.8294 21.579 20.0065 21.6958 20.1552 21.8442C20.3038 21.9925 20.4209 22.1695 20.4993 22.3643L22.9726 28.5335Z" stroke="white" strokeWidth="1.55553" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M28.663 13.3345L20.1543 21.8424" stroke="white" strokeWidth="1.55553" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
